export default "__VITE_ASSET__CpeXCJtk__"